// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__X5mMG","button":"styles_button__1GfOQ","textInput":"styles_textInput__1p8O0"};